/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Kits_LessInputs */

const en_fw_kits_less = /** @type {(inputs: Fw_Kits_LessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show fewer`)
};

const id_fw_kits_less = /** @type {(inputs: Fw_Kits_LessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tampilkan lebih sedikit`)
};

/**
* | output |
* | --- |
* | "Show fewer" |
*
* @param {Fw_Kits_LessInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_kits_less = /** @type {((inputs?: Fw_Kits_LessInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Kits_LessInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_kits_less(inputs)
	return en_fw_kits_less(inputs)
});